export default __webpack_public_path__ + "static/media/hackathon.741a0298.svg";